import {useEffect} from 'react';
import {getTeamCredits} from '@Components/team-credits/team-credits-library';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {USER_AUTHENTICATED_EVENT} from '@Libraries/user.library';
import {resetTeamCredits} from '@Components/team-credits/team-credits-slice';

export function useGetTeamCredits(): number | null {
  const teamCredits = useAppSelector((state) => {
    return state.teamCredits.credits;
  });
  const dispatch = useAppDispatch();

  useEffect(() => {
    void getTeamCredits();

    const refreshCredits = (): void => {
      dispatch(resetTeamCredits());
      void getTeamCredits();
    };

    document.addEventListener(USER_AUTHENTICATED_EVENT, refreshCredits);

    return (): void => {
      document.removeEventListener(USER_AUTHENTICATED_EVENT, refreshCredits);
    };
  }, [dispatch]);

  return teamCredits;
}
